import { IonCol, IonItem, IonModal, IonRow, IonText } from "@ionic/react";
import { useEffect, useState } from "react";
import { makeGETRequest, makePATCHRequest } from "../../request/rawRequest";
import { User } from "../../types/user";
import AccountImg from "./AccountImg";
import BackGroundImg from "./BackGroundImg";

import { useHistory } from "react-router";
import { jobs, jobsArray, jobsKeys } from "../../variables/jobsDictionnary";
import { displayTechnoActive, technosActive } from "../TechnoList/TechnoList";
import "../TechnoList/TechnoList.css";
import "./Me.css";
import PathReturn from "./PathReturn";

interface Prop {
  pathReturn?: string;
}

const getPremium = (
  actual: string
): {
  value: string;
  display: string;
} => {
  switch (actual) {
    case "pat":
      return { value: "boul", display: "Accès au CAP Boulangerie" };
    case "boul":
      return { value: "pat", display: "Accès au CAP Patisserie" };
  }
  return { value: "not", display: "Aucune autre technologie disponible" };
};

const specialEmails: string[] = [
  "patisriviere@gmail.com",
  "jean-luc.duvin@cma-nouvelleaquitaine.fr",
  "david.bret@cma-nouvelleaquitaine.fr",
  "vincent.cecile.debains@orange.fr",
  "xgeoffroy@ceproc.com",
];

const Me: React.FC<Prop> = ({ pathReturn }) => {
  const history = useHistory();
  const [notifNumber, setNotifNumber] = useState<number>(0);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const otherTechno = getPremium(localStorage.getItem("techno") ?? "");
  const [user, setUser] = useState<User>({
    creation_date: "",
    email: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    picture_url: "",
    role: "",
    validated: false,
    premium: false,
    pole: "",
    level: 0,
  });

  async function getNotifLength() {
    await makeGETRequest("/notifications").then((res) => {
      if (res) {
        setNotifNumber(res.length);
      } else {
        setNotifNumber(0);
      }
    });
  }

  const getUserData = async () => {
    if (user.email === "") {
      await makeGETRequest("/me").then((res) => {
        setUser(res);
      });
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  useEffect(() => {
    if (user.validated === true) {
      getNotifLength();
    }
  }, [user]);

  useEffect(() => {
    if (
      user &&
      user.email &&
      user.email.length > 0 &&
      !window.location.pathname.includes("notvalid") &&
      !window.location.pathname.includes("account")
    ) {
      if (user.validated === false) {
        history.push("/notvalid");
        // window.location.href ="/notvalid" ;
      }

      if (
        jobsKeys.includes(user.pole) &&
        user.pole !== localStorage.getItem("techno")
      ) {
        localStorage.setItem("techno", user.pole);

        window.location.reload();
      } else if (!jobsKeys.includes(user.pole)) {
        setModalOpen(true);
      } else if (localStorage.getItem("techno") === undefined) {
        localStorage.clear();
        history.push("/");
      }
    }
  }, [user]);

  const imgStyle = {
    backgroundColor: "black",
    borderRadius: "20px 0 0 20px",
  };

  return (
    <IonRow
      className="ion-justify-content-center"
      style={{ paddingTop: "50px" }}
    >
      <IonModal isOpen={modalOpen} canDismiss={false}>
        <IonItem className="ion-text-center">
          <h3 className="ion-text-center">Veuillez choisir une technologie</h3>
        </IonItem>
        <IonCol>{displayTechnoActive(technosActive, "12", true)}</IonCol>
      </IonModal>
      <IonCol size-lg="5" size-sm="10">
        <IonRow className="ion-justify-content-center">
          <IonCol
            size-lg="3"
            size="3"
            size-sm="3"
            style={imgStyle}
            className="clickable"
          >
            <AccountImg user={user} />
            <PathReturn pathReturn={pathReturn} />
          </IonCol>
          <BackGroundImg
            imageLink={
              jobs.get(localStorage.getItem("techno") ?? "")?.image ?? ""
            }
          />
        </IonRow>

        {user.validated ? (
          user.role === "admin" || specialEmails.includes(user.email) ? (
            <IonRow
              className="ion-justify-content-end"
              style={{
                marginTop: "15px",
              }}
            >
              {jobsArray.map((pole, index) => (
                <IonCol
                  key={index}
                  className="ion-justify-content-end flex"
                  size="min"
                >
                  <IonText
                    className="btn"
                    style={{
                      padding: "5px",
                      width: "auto",
                    }}
                    onClick={async () => {
                      localStorage.setItem("techno", pole.href);

                      await makePATCHRequest(
                        "/pole?pole=" + localStorage.getItem("techno")
                      )
                        .then(() => {
                          // window.location.href = "/";
                          history.push("/");
                        })
                        .catch(() => {
                          localStorage.removeItem("authToken");
                        });
                    }}
                  >
                    {pole.labelUpper}
                  </IonText>
                </IonCol>
              ))}
            </IonRow>
          ) : user.premium ? (
            <IonRow
              className="ion-justify-content-end"
              style={{
                marginTop: "15px",
              }}
            >
              <IonCol
                className="ion-justify-content-end flex"
                size-lg="5"
                size-sm="10"
              >
                <IonText
                  className="btn"
                  style={{
                    padding: "5px",
                    width: "auto",
                  }}
                  onClick={async () => {
                    if (otherTechno.value !== "not") {
                      localStorage.setItem("techno", otherTechno.value);

                      await makePATCHRequest("/pole?pole=" + otherTechno.value)
                        .then(() => {
                          window.location.reload();
                        })
                        .catch(() => {
                          localStorage.removeItem("authToken");
                        });
                    }
                  }}
                >
                  {otherTechno.display}
                </IonText>
              </IonCol>
            </IonRow>
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </IonCol>
    </IonRow>
  );
};

export default Me;
